import type { ReactNode } from 'react';

interface ContentStateProps {
  loading: boolean;
  error: string | null;
  ready: boolean;
  onRetry: () => void;
  children: ReactNode;
}

export default function ContentState({
  loading,
  error,
  ready,
  onRetry,
  children,
}: ContentStateProps) {
  if (loading) {
    return (
      <div className="w-full flex flex-col items-center justify-center gap-5 py-10">
        <div className="h-8 w-52 animate-pulse rounded-lg bg-background-100" />
        <div className="h-4 w-2/3 max-w-md animate-pulse rounded bg-background-100" />
        <div className="grid w-full max-w-4xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-32 animate-pulse rounded-xl bg-background-100" />
          ))}
        </div>
      </div>
    );
  }

  if (error || !ready) {
    return (
      <div className="w-full flex flex-col items-center justify-center gap-4 py-10">
        <p className="text-sm text-secondary-500">
          {error || 'This content is currently unavailable.'}
        </p>
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center gap-2 rounded-lg bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          <i className="ri-refresh-line" />
          Try again
        </button>
      </div>
    );
  }

  return <>{children}</>;
}